import type { SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "@/types/database.types";

/**
 * Loads the Supabase browser client on demand. Code that runs on every page
 * (header, analytics, tRPC auth headers) uses this so supabase-js stays out
 * of the bundle that blocks the first render.
 */
export async function loadSupabaseClient(): Promise<SupabaseClient<Database>> {
  const { createClient } = await import("@/lib/supabase/client");
  return createClient();
}
